import { api } from "../api/client";

/**
 * The panel's half of watching the show (`R-VID-9`).
 *
 * One route, and it is the **public** one a viewer uses: `viewer-token.ts` authenticates
 * optionally, falls back to an anonymous participant id, and does not care which hostname asked
 * — the chat token is reached the same way from here (`chat/api.ts` says so at length). So a
 * panel watching a show is a subscriber like any other, holding a `SUBSCRIBE`-only capability
 * that IVS enforces, and no new privilege was invented to make this card work.
 */

export interface ViewerToken {
  token: string;
  participantId: string;
  expiresInSeconds: number;
}

/** A `SUBSCRIBE`-only token for this show's stage. Asked for afresh on every join attempt. */
export const viewerToken = (publicId: string) =>
  api
    .post<{ viewer: ViewerToken }>(
      `/api/public/shows/${encodeURIComponent(publicId)}/viewer-token`,
    )
    .then((answer) => answer.viewer);
